import PropTypes from 'prop-types'
import React from 'react'
import { ContextMenu, MenuItem } from 'react-contextmenu'
import * as folderConstants from '../../dux/constants/folder'
import { getConsumedMeta } from '../../dux/modules/sharedEndpoints'
import { validatePrivilege } from '../../dux/modules/utils'
import { isConsumedFolder } from './sidebarUtils'

const FolderMenu = (props) => {
  const { id, trigger, allFolders, endpoints } = props

  const handleItemClick = trigger ? trigger.onItemClick : null

  const folderType = trigger
    ? allFolders[trigger.name].type
    : folderConstants.INVALID_FOLDER_TYPE

  // Consumed shared-endpoint folders are read-only in this instance
  // (SHARED-ENDPOINTS-PLAN.md §4.5): every folder action mutates the
  // provider's content, so none of them are offered — except that an
  // UNLOCKED grant lets content admins Publish Folder a subtree into their
  // own Published tree (plan Phase 8). That creates the consumer's own
  // folders; the shared folders themselves are never modified.
  const consumed = trigger ? isConsumedFolder(trigger.name, allFolders) : false
  const consumedMeta = consumed
    ? getConsumedMeta(allFolders[trigger.name])
    : null
  const unlocked = !!(consumedMeta && consumedMeta.mode === 'unlocked')
  const allowedForConsumed = [folderConstants.PUBLISH_FOLDER_ACTION]

  // A consumed endpoint ROOT is typed 'sharedfolder' (the provider's type),
  // whose action list has no Publish Folder; consumed folders are offered the
  // ordinary folder actions (filtered to allowedForConsumed) so the whole
  // endpoint can be published from its root.
  const actionsType = consumed
    ? folderConstants.DEFAULT_FOLDER_TYPE
    : folderType
  const typeActions = (
    folderConstants.FOLDER_TYPE_ACTIONS[actionsType] || { actions: [] }
  ).actions

  const actions =
    consumed && !unlocked
      ? []
      : typeActions.filter((action) => {
          if (consumed && allowedForConsumed.indexOf(action.type) < 0)
            return false
          let allowed = true
          action.exceptions.forEach((exception) => {
            if (allowed)
              allowed = !exception(
                trigger.name,
                allFolders,
                folderConstants,
                folderType,
                // isNotLibraryFolder resolves the Library root from the LIB
                // endpoint rather than assuming the literal '_library'
                endpoints,
              )
          })
          return allowed
        })

  return (
    <ContextMenu
      id={id}
      hideOnLeave={true}
      className={actions.length === 0 ? 'hide' : ''}
    >
      {actions.map((action) => {
        return (
          <MenuItem
            key={action.type}
            onClick={handleItemClick}
            data={{
              action: action.type,
              folderId: trigger.name,
              relationships: props.relationships,
            }}
            disabled={
              !validatePrivilege(
                folderConstants.FOLDER_ACTIONS[action.type].privilege,
                props.privileges,
                props.email,
                props.groups,
                trigger.name,
                props.allFolders,
              )
            }
          >
            {action.type}
          </MenuItem>
        )
      })}
    </ContextMenu>
  )
}

FolderMenu.propTypes = {
  id: PropTypes.string.isRequired,
  endpoints: PropTypes.array,
  trigger: PropTypes.shape({
    name: PropTypes.string,
    onItemClick: PropTypes.func,
  }),
  bin: PropTypes.string,
  allFolders: PropTypes.object,
  privileges: PropTypes.object,
  groups: PropTypes.object,
  email: PropTypes.string,
  relationships: PropTypes.object,
}

export default FolderMenu
